import { css } from '@emotion/react';

import { COLORS, FONT_SIZE, FONT_WEIGHT } from '~/configs/theme.ts';

import type { CSSProperties, PropsWithChildren } from 'react';

export interface HeadingProps extends PropsWithChildren {
  className?: string;
  color?: string;
  fontWeight?: Lowercase<keyof typeof FONT_WEIGHT>;
  size?: 'xSmall' | 'small' | 'medium' | 'large' | number;
  style?: CSSProperties;
}

function Heading({
  children,
  className,
  color = COLORS.GRAY['900'],
  fontWeight = 'extra_bold',
  size = 'medium',
  style = {},
}: HeadingProps) {
  return (
    <h1
      className={className}
      css={[styles.base(fontWeight), typeof size === 'string' ? styles[size] : styles.size(size)]}
      style={{ color, ...style }}
    >
      {children}
    </h1>
  );
}

const styles = {
  base: (fontWeight: Lowercase<keyof typeof FONT_WEIGHT>) => css`
    font-weight: ${FONT_WEIGHT[fontWeight.toUpperCase() as keyof typeof FONT_WEIGHT]};
    font-style: normal;
    line-height: 128%;
  `,

  large: css`
    font-size: ${FONT_SIZE['24']};
  `,

  medium: css`
    font-size: ${FONT_SIZE['20']};
  `,

  size: (fontSize: number) => css`
    font-size: ${fontSize}px;
  `,

  small: css`
    font-size: ${FONT_SIZE['18']};
  `,

  xSmall: css`
    font-size: ${FONT_SIZE['16']};
  `,
};

export default Heading;
